export class PermissionGrantInput {
    'permission';
    'accessConditionId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "permission",
            "baseName": "permission",
            "type": "PermissionType",
            "format": ""
        },
        {
            "name": "accessConditionId",
            "baseName": "accessConditionId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PermissionGrantInput.attributeTypeMap;
    }
    constructor() {
    }
}
